module.exports = __webpack_public_path__ + "static/media/IMG_9092.0244cc2f.JPG";